import { render, staticRenderFns } from "./LogosSection.vue?vue&type=template&id=2b599e8f&scoped=true&"
import script from "./LogosSection.vue?vue&type=script&lang=ts&"
export * from "./LogosSection.vue?vue&type=script&lang=ts&"
import style0 from "./LogosSection.vue?vue&type=style&index=0&id=2b599e8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b599e8f",
  null
  
)

export default component.exports